function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.control = this.querySelector('input, select');
    this.changeEvent = new Event('change', { bubbles: true });
    this.control.addEventListener('change', this.onControlChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onControlChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const isInput = this.control.tagName.toLowerCase() === 'input';
    const previousValue = isInput ? this.control.value : this.control.options[this.control.selectedIndex].value;

    if (isInput) {
      event.target.name === 'plus' ? this.control.stepUp() : this.control.stepDown();
    } else {
      let index = this.control.selectedIndex;
      event.target.name === 'plus' ? index++ : index--;
      if (index >= 0 && index < this.control.options.length) {
        this.control.selectedIndex = index;
      }
    }

    const currentValue = isInput ? this.control.value : this.control.options[this.control.selectedIndex].value;
    if (previousValue !== currentValue) this.control.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    if (!this.control) return; 
  
    const isInput = this.control.tagName.toLowerCase() === 'input';
    const value = parseInt(isInput ? this.control.value : this.control.options[this.control.selectedIndex].value);
  
    if (this.control.min) {
      const min = parseInt(this.control.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) buttonMinus.classList.toggle('disabled', value <= min);
    }
  
    if (this.control.max) {
      const max = parseInt(this.control.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
  
}

customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
            totalPages: this.totalPages
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    // Update button states
    const isAtStart = this.slider.scrollLeft <= 0;
    const isAtEnd = this.slider.scrollLeft >= (this.slider.scrollWidth - this.slider.clientWidth - 1);

    this.prevButton.disabled = isAtStart;
    this.nextButton.disabled = isAtEnd;

    this.prevButton.classList.toggle('disabled', isAtStart);
    this.nextButton.classList.toggle('disabled', isAtEnd);
  }

  isSlideVisible(element, offset = 0) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const containerRect = this.slider.getBoundingClientRect();
    const isVisible = rect.left >= containerRect.left - 1 && rect.right <= containerRect.right + 1;
    return isVisible;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);

class ProductGalleryNavigation extends HTMLElement {
  constructor() {
    super();
    this.mediaGallery = this.closest('media-gallery');
    this.sliderComponent = this.mediaGallery?.querySelector('slider-component');
    this.mainSlider = this.sliderComponent?.querySelector('[id^="Slider-Gallery-"]');
    this.thumbnailSlider = this.mediaGallery?.querySelector('[id^="Slider-Thumbnails-"]');
    this.thumbnailButtons = this.thumbnailSlider?.querySelectorAll('.thumbnail');
    this.prevButton = this.querySelector('.slider-button-main-image__prev');
    this.nextButton = this.querySelector('.slider-button-main-image__next');
    
    this.currentIndex = 0;
    this.totalSlides = 0;
    this.isNavigating = false;
    
    this.init();
  }

  init() {
    if (!this.mediaGallery || !this.mainSlider || !this.prevButton || !this.nextButton) {
      return;
    }

    this.updateVisibleSlides();
    
    if (this.totalSlides <= 1) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    // Always show buttons if we have more than one slide
    this.prevButton.style.display = '';
    this.nextButton.style.display = '';

    this.prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.navigate('prev');
    });
    
    this.nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.navigate('next');
    });


    document.addEventListener('variant:changed', (event) => {
      this.reinitializeSlides();
    });

    this.sliderComponent?.addEventListener('slideChanged', (event) => {
      this.syncCurrentIndex();
    });


    this.syncCurrentIndex();
    this.updateButtonState();
    

    this.preventSliderComponentInterference();
  }

  updateVisibleSlides() {

    const visibleThumbnails = this.thumbnailSlider 
      ? Array.from(this.thumbnailSlider.querySelectorAll('.thumbnail-list__item')).filter(thumb => {
          return window.getComputedStyle(thumb).display !== 'none';
        })
      : [];


    this.slides = [];
    if (visibleThumbnails.length > 0) {
      visibleThumbnails.forEach(thumb => {
        const targetId = thumb.getAttribute('data-target');
        if (targetId) {
          const slide = this.mainSlider.querySelector(`[data-media-id="${targetId}"]`);
          if (slide) {
            this.slides.push(slide);
          }
        }
      });
    } else {

      this.slides = Array.from(this.mainSlider.querySelectorAll('[id^="Slide-"]')).filter(slide => {
        return window.getComputedStyle(slide).display !== 'none';
      });
    }
    
    this.totalSlides = this.slides.length;
  }

  syncCurrentIndex() {
    const currentSlide = this.mainSlider.querySelector('.is-active[data-media-id]');
    if (currentSlide) {
      const index = this.slides.indexOf(currentSlide);
      if (index !== -1) {
        this.currentIndex = index;
        this.updateButtonState();
      }
    }
  }

  preventSliderComponentInterference() {

    if (this.sliderComponent) {
      const originalUpdate = this.sliderComponent.update;
      this.sliderComponent.update = function() {

        const prevButton = this.querySelector('.slider-button-main-image__prev');
        const nextButton = this.querySelector('.slider-button-main-image__next');
        

        const prevState = {
          disabled: prevButton?.disabled,
          classList: prevButton?.classList.toString()
        };
        const nextState = {
          disabled: nextButton?.disabled,
          classList: nextButton?.classList.toString()
        };
        

        originalUpdate.call(this);
        

        if (prevButton && this.closest('media-gallery')) {
          prevButton.removeAttribute('disabled');
          prevButton.classList.remove('disabled');
          prevButton.style.pointerEvents = 'auto';
        }
        if (nextButton && this.closest('media-gallery')) {
          nextButton.removeAttribute('disabled');
          nextButton.classList.remove('disabled');
          nextButton.style.pointerEvents = 'auto';
        }
      };
    }
  }

  getVisibleSlideIndex() {
    const allSlides = Array.from(this.mainSlider.querySelectorAll('[id^="Slide-"]'));
    const visibleSlideIndex = allSlides.findIndex(slide => {
      const rect = slide.getBoundingClientRect();
      const containerRect = this.mainSlider.getBoundingClientRect();
      return rect.left >= containerRect.left - 1 && rect.right <= containerRect.right + 1;
    });
    return visibleSlideIndex;
  }

  reinitializeSlides() {

    this.updateVisibleSlides();
    

    this.syncCurrentIndex();
    
    this.updateButtonState();
  }

  navigate(direction) {
    if (this.isNavigating) return; 
    

    this.syncCurrentIndex();
    
    if (direction === 'prev' && this.currentIndex > 0) {
      this.goToSlide(this.currentIndex - 1);
    } else if (direction === 'next' && this.currentIndex < this.totalSlides - 1) {
      this.goToSlide(this.currentIndex + 1);
    }
  }

  goToSlide(index) {
    if (index < 0 || index >= this.totalSlides) {
      return;
    }
    
    if (this.isNavigating) return;
    this.isNavigating = true; 
    
    this.currentIndex = index;
    

    const targetSlide = this.slides[index];
    if (!targetSlide) {
      this.isNavigating = false;
      return;
    }
    
    const slideMediaId = targetSlide.getAttribute('data-media-id');
    
    if (this.thumbnailSlider && slideMediaId) {
      const matchingThumbnailLi = this.thumbnailSlider.querySelector(`[data-target="${slideMediaId}"]`);
      const matchingThumbnailButton = matchingThumbnailLi?.querySelector('button.thumbnail');
      
      if (matchingThumbnailButton) {
        matchingThumbnailButton.click();
      } else {

        this.mainSlider.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
      }
    } else {

      this.mainSlider.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
      });
    }
    
    this.updateButtonState();
    
    // Reset flag after a short delay to allow the navigation to complete
    setTimeout(() => {
      this.isNavigating = false;
    }, 100);
  }

  updateButtonState() {
    if (this.totalSlides <= 1) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    // Always keep buttons visible if we have multiple slides
    this.prevButton.style.display = '';
    this.nextButton.style.display = '';
    this.prevButton.style.visibility = 'visible';
    this.nextButton.style.visibility = 'visible';

    // Update disabled state
    const isAtStart = this.currentIndex === 0;
    const isAtEnd = this.currentIndex === this.totalSlides - 1;

    // Remove any SliderComponent interference
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
    this.prevButton.classList.remove('disabled');
    this.nextButton.classList.remove('disabled');

    // Apply our own disabled state
    if (isAtStart) {
      this.prevButton.classList.add('disabled');
    }
    if (isAtEnd) {
      this.nextButton.classList.add('disabled');
    }

    // Ensure buttons remain clickable
    this.prevButton.style.pointerEvents = 'auto';
    this.nextButton.style.pointerEvents = 'auto';
  }
}

customElements.define('product-gallery-navigation', ProductGalleryNavigation);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ImageTextOverlaySlider extends SlideshowComponent {
  constructor() {
    super();
    this.slider = this.querySelector('.slider');
    this.sliderItems = this.querySelectorAll('.slideshow__slide');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotButtons = this.querySelectorAll('.slider-counter__link');
    this.currentPage = 1;

    if (!this.slider || !this.sliderItems.length) return;

    this.initializeSlider();
  }

  initializeSlider() {
    // Add event listeners for navigation
    if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
    // Add event listeners for dots
    this.dotButtons.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index + 1));
    });

    // Set initial state
    this.updateSlideVisibility();
    this.setInitialPosition();
  }

  setInitialPosition() {
    this.sliderItems.forEach((slide, index) => {
      slide.style.transform = `translateX(${index * 100}%)`;
    });
    this.updateActiveDot(1);
  }

  onButtonClick(event) {
    event.preventDefault();
    const isNext = event.currentTarget.name === 'next';
    const newPage = isNext ? this.currentPage + 1 : this.currentPage - 1;
    
    if (newPage < 1) {
      this.goToSlide(this.sliderItems.length);
    } else if (newPage > this.sliderItems.length) {
      this.goToSlide(1);
    } else {
      this.goToSlide(newPage);
    }
  }

  goToSlide(slideNumber) {
    this.currentPage = slideNumber;
    const offset = -(slideNumber - 1) * 100;
    
    this.sliderItems.forEach(slide => {
      slide.style.transition = 'transform 0.5s ease-in-out';
      slide.style.transform = `translateX(${offset}%)`;
    });

    this.updateActiveDot(slideNumber);
    this.updateSlideVisibility();
  }

  updateActiveDot(slideNumber) {
    this.dotButtons.forEach((dot, index) => {
      if (index + 1 === slideNumber) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  updateSlideVisibility() {
    this.sliderItems.forEach((slide, index) => {
      if (index + 1 === this.currentPage) {
        slide.removeAttribute('hidden');
      } else {
        slide.setAttribute('hidden', '');
      }
    });
  }
}

customElements.define('image-text-overlay-slider', ImageTextOverlaySlider);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        const notifyForm = document.querySelector('#esc-oos-form');

        setTimeout(() => {
          if(notifyForm) {
            if(!addButtonUpdated.hasAttribute('disabled')) {
                notifyForm.style.display = 'none';
            }else {
                notifyForm.style.display = 'block';
            }
          }
        }, 500);


        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initGlider();
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  initGlider() {
    const slider = this.querySelector('.related-product__slider');
    if (slider) {
      new Glider(slider, {
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable: true,
        arrows: {
          prev: this.querySelector('.glider-prev'), 
          next: this.querySelector('.glider-next') 
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3, 
              slidesToScroll: 1,
              draggable: true
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5.5,
              slidesToScroll: 1,
              draggable: true
            }
          }
        ]
      });
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

var howWorksTrigger = document.querySelector('.mobile-how-works__trigger a');
var howWorksSteps = document.querySelector('.how-works__steps');
var howWorksOverlay = document.querySelector('.how-works__overlay');
var howWorksCloseBtn = document.querySelector('.how-works__close-btn');
var body = document.body;

function openModal() {
    if (howWorksSteps && howWorksOverlay && body) {
        howWorksSteps.style.transform = 'translateX(-100%)';
        howWorksOverlay.style.display = 'block !important';
        body.classList.add('modal-open');
        body.style.overflow = 'hidden';
    }
}

function closeModal() {
    if (howWorksSteps && howWorksOverlay && body) {
        howWorksSteps.style.transform = 'translateX(0)';
        howWorksOverlay.style.display = 'none !important';
        body.classList.remove('modal-open');
        body.style.overflow = 'auto';
    }
}

if (howWorksTrigger) {
    howWorksTrigger.addEventListener('click', function(event) {
        event.preventDefault();
        openModal();
    });
}

if (howWorksOverlay) {
    howWorksOverlay.addEventListener('click', closeModal);
}

if (howWorksCloseBtn) {
    howWorksCloseBtn.addEventListener('click', closeModal);
}



var glider;

function initializeGlider() {
  var gliderElement = document.querySelector('.how-works__wrapper');

  if (!gliderElement) return;

  if (window.innerWidth <= 768 && !glider) {
    glider = new Glider(gliderElement, {
      slidesToShow: 2,
      slidesToScroll: 1,
      draggable: true,
      arrows: {
        prev: '.how-works__steps .glider-prev',
        next: '.how-works__steps .glider-next'
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: true
          }
        }
      ]
    });
  } else if (window.innerWidth > 768 && glider) {
    glider.destroy();
    glider = null;
  }
}

initializeGlider();

window.addEventListener('resize', initializeGlider);



var hemperBoxSlider = document.querySelector('.hemper-box__slider');

if (hemperBoxSlider) {
  new Glider(hemperBoxSlider, {
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    scrollLock: true,
    dots: '#dots',
    arrows: {
      prev: '.product-feature__container .glider-prev',
      next: '.product-feature__container .glider-next'
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          duration: 0.5
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('.category-tabs__input');
  var contents = document.querySelectorAll('.category-grid');

  tabs.forEach(function(tab) {
    tab.addEventListener('change', function(event) {
      var tabId = event.target.getAttribute('id');
      var label = document.querySelector('label[for="' + tabId + '"]');
      var tabData = label.getAttribute('data-tab');

      contents.forEach(function(content) {
        content.style.display = 'none';
      });

      var selectedContent = document.querySelector('.category-grid[data-tab="' + tabData + '"]');
      if (selectedContent) {
        selectedContent.style.display = 'grid';
      }
    });
  });

  if (tabs.length > 0 && contents.length > 0) {
    var firstTabData = document.querySelector('.category-tabs__label').getAttribute('data-tab');
    var firstContent = document.querySelector('.category-grid[data-tab="' + firstTabData + '"]');
    if (firstContent) {
      firstContent.style.display = 'grid';
    }
  }
});


// FOOTER NAV CODE to send data to GA

var footerMenus = document.querySelectorAll('a.footer-nav-item');
var htmlSelector = document.querySelector('html');

footerMenus.forEach(function (menu) {
    menu.addEventListener('click', function (evt) {
        evt.preventDefault();
      console.log('footer menu clicked');
        ga('send', 'event', 'Menu Bar', 'tap', this.getAttribute('data-title'));


        if (this.getAttribute('data-title') === 'menu') {
            var mobileNavMenu = document.querySelector('#mobile-main-nav');

            if (htmlSelector.classList.contains('mm-wrapper_opened')) {
                this.parentNode.classList.remove('menu-open');
                this.classList.remove('is-active');
            }
            else {
                this.parentNode.classList.add('menu-open');
                this.classList.add('is-active');
            }

            if (mobileNavMenu.classList.contains('mobile-menu-active')) {
                mobileNavMenu.classList.remove('mobile-menu-active');
                htmlSelector.classList.remove('mm-wrapper_blocking');
            } else {
                mobileNavMenu.classList.add('mobile-menu-active');
                htmlSelector.classList.add('mm-wrapper_blocking');
            }
        } else {
            this.classList.toggle('is-active');
            window.location.href = this.getAttribute('href');
        }
    });
});

var collectionNavSlider = document.querySelector('.collection_nav');
if (collectionNavSlider) {
  const slideCount = document.querySelectorAll('.collection_nav .glide__slide').length;
  const shouldShowArrowsAndDots = slideCount > 8 || window.innerWidth <= 1268;

  new Glider(collectionNavSlider, {
    slidesToShow: 'auto',
    slidesToScroll: 1,
    scrollLock: true,
    draggable: true,
    arrows: shouldShowArrowsAndDots ? {
      prev: '.collection-nav__container .glider-prev',
      next: '.collection-nav__container .glider-next'
    } : false,
    responsive: [
      {
        breakpoint: 775,
        settings: {
          slidesToShow: 'auto',
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 'auto',
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1268,
        settings: {
          slidesToShow: 'auto',
          slidesToScroll: 1,
          draggable: true,
          arrows: slideCount > 8 ? {
            prev: '.collection-nav__container .glider-prev',
            next: '.collection-nav__container .glider-next'
          } : false,
        }
      }
    ]
  }); 
}

if (!customElements.get('onetime-purchase')) {
  customElements.define(
    'onetime-purchase',
    class OnetimePurchase extends HTMLElement {
      constructor() {
        super();
        this.purchaseOptions = null;
        this.selectedType = 'onetime';
        this.productForm = this.closest('product-form');
        this.variantIdInput = this.productForm?.querySelector('input[name="id"]');
        this.init();
      }

      init() {
        this.purchaseOptions = JSON.parse(this.dataset.offers);
        this.render();
        this.attachEventListeners();
      }

      render() {
        const template = `
          <div class="onetime-purchase">
            <div class="onetime-purchase__options">
              <label class="onetime-purchase__radio">
                <input 
                  type="radio" 
                  name="purchase_type" 
                  value="onetime" 
                  class="onetime-purchase__radio-input"
                  ${this.selectedType === 'onetime' ? 'checked' : ''}
                >
                <span class="onetime-purchase__radio-label">
                  One-time purchase
                  <span class="onetime-purchase__price">
                    $${this.purchaseOptions.data[this.purchaseOptions.onetime[0]].price}
                  </span>
                </span>
              </label>

              <label class="onetime-purchase__radio">
                <input 
                  type="radio" 
                  name="purchase_type" 
                  value="subscription" 
                  class="onetime-purchase__radio-input"
                  ${this.selectedType === 'subscription' ? 'checked' : ''}
                >
                <span class="onetime-purchase__radio-label">
                  Subscribe & Save
                </span>
              </label>
            </div>

            <div class="onetime-purchase__subscription-options" ${this.selectedType === 'onetime' ? 'hidden' : ''}>
              <select class="onetime-purchase__select">
                ${this.purchaseOptions.recurring.map(id => `
                  <option value="${id}">
                    ${this.purchaseOptions.data[id].title}
                  </option>
                `).join('')}
              </select>
            </div>
          </div>
        `;

        this.innerHTML = template;
      }

      attachEventListeners() {
        const radioInputs = this.querySelectorAll('.onetime-purchase__radio-input');
        const subscriptionSelect = this.querySelector('.onetime-purchase__select');
        const subscriptionOptions = this.querySelector('.onetime-purchase__subscription-options');

        radioInputs.forEach(input => {
          input.addEventListener('change', (e) => {
            this.selectedType = e.target.value;
            subscriptionOptions.toggleAttribute('hidden', this.selectedType === 'onetime');
            
            // Update variant ID in the product form
            if (this.variantIdInput) {
              if (this.selectedType === 'onetime') {
                this.variantIdInput.value = this.purchaseOptions.onetime[0];
              } else {
                this.variantIdInput.value = subscriptionSelect.value;
              }
            }
          });
        });

        subscriptionSelect?.addEventListener('change', (e) => {
          if (this.variantIdInput) {
            this.variantIdInput.value = e.target.value;
          }
        });
      }
    }
  );
}

var gliderElement = document.querySelector('.glider.image-slider');

if (gliderElement) {
    const gliderSpeed = parseInt(gliderElement.getAttribute('data-speed')) || 3000;
    const enableSlider = gliderElement.getAttribute('data-enable-slider') === 'true';
    const enableAutoplay = gliderElement.getAttribute('data-enable-autoplay') === 'true';
    
    if (enableSlider) {
        var glider = new Glider(gliderElement, {
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            dragVelocity: 1.5,
            duration: 0.8,
            scrollLock: true,
            rewind: true,
            arrows: {
                prev: '.glider-prev',
                next: '.glider-next'
            }
        });

        function sliderAutoPlay(glider, interval) {
            let autoplay = setInterval(function() {
                if (glider.slide < glider.slides.length - 1) {
                    glider.scrollItem(glider.slide + 1);
                } else {
                    glider.scrollItem(0);
                }
            }, interval);

            glider.ele.addEventListener('mouseover', function() {
                clearInterval(autoplay);
            });

            glider.ele.addEventListener('mouseout', function() {
                if (!enableAutoplay) return;
                autoplay = setInterval(function() {
                    if (glider.slide < glider.slides.length - 1) {
                        glider.scrollItem(glider.slide + 1);
                    } else {
                        glider.scrollItem(0);
                    }
                }, interval);
            });
        }

        if (enableAutoplay) {
            sliderAutoPlay(glider, gliderSpeed);
        }
    }
}

class CartRecommendation extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.recommendation-slider');
    this.slides = this.querySelectorAll('.recommendation-slide');
    this.prevButton = this.closest('.cart-drawer__upsell').querySelector('[data-action="prev"]');
    this.nextButton = this.closest('.cart-drawer__upsell').querySelector('[data-action="next"]');
    
    if (!this.slider || !this.slides.length) return;
    
    this.isDragging = false;
    this.startPos = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.currentX = 0;
    
    this.init();
  }

  init() {
    this.updateButtonStates();
    this.bindEvents();
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.navigate('prev'));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.navigate('next'));
    }

    // Mouse events
    this.slider.addEventListener('mousedown', this.startDragging.bind(this));
    window.addEventListener('mousemove', this.drag.bind(this));
    window.addEventListener('mouseup', this.stopDragging.bind(this));
    
    // Touch events
    this.slider.addEventListener('touchstart', this.startDragging.bind(this));
    window.addEventListener('touchmove', this.drag.bind(this));
    window.addEventListener('touchend', this.stopDragging.bind(this));

    // Prevent context menu during drag
    this.slider.addEventListener('contextmenu', (e) => {
      if (this.isDragging) e.preventDefault();
    });

    // Update button states on scroll
    this.slider.addEventListener('scroll', () => {
      requestAnimationFrame(() => this.updateButtonStates());
    });
  }

  startDragging(e) {
    this.isDragging = true;
    this.slider.style.cursor = 'grabbing';
    this.slider.style.userSelect = 'none';
    
    // Get the starting position
    this.startPos = this.getPositionX(e);
    this.currentX = this.slider.scrollLeft;
  }

  drag(e) {
    if (!this.isDragging) return;
    e.preventDefault();

    // Calculate how far the mouse has moved
    const currentPosition = this.getPositionX(e);
    const diff = this.startPos - currentPosition;
    
    // Scroll the slider
    this.slider.scrollLeft = this.currentX + diff;
  }

  stopDragging() {
    this.isDragging = false;
    this.slider.style.cursor = '';
    this.slider.style.userSelect = '';
  }

  getPositionX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  navigate(direction) {
    if (!this.slider || !this.slides.length) return;

    const slideWidth = this.slides[0].offsetWidth;
    const currentScroll = this.slider.scrollLeft;
    const gap = 15; // Same as CSS gap

    const targetScroll = direction === 'next' 
      ? currentScroll + slideWidth + gap
      : currentScroll - slideWidth - gap;

    this.slider.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }

  updateButtonStates() {
    if (!this.slider) return;

    const isAtStart = this.slider.scrollLeft <= 0;
    const isAtEnd = this.slider.scrollLeft >= (this.slider.scrollWidth - this.slider.offsetWidth - 1);

    if (this.prevButton) {
      this.prevButton.disabled = isAtStart;
    }
    if (this.nextButton) {
      this.nextButton.disabled = isAtEnd;
    }
  }
}

customElements.define('cart-recommendation', CartRecommendation);

class CollectionsListing extends HTMLElement {
  constructor() {
      super();
      this.itemsPerBatch = parseInt(this.dataset.itemsPerBatch) || 10;
      this.useMetafields = this.hasAttribute('data-use-metafields');
      this.boundHandleHashChange = this.handleExpandedParameter.bind(this);
  }

  connectedCallback() {
      this.loadMoreButton = this.querySelector('#loadMoreCollections');
      this.categoryLoadMoreButtons = this.querySelectorAll('.load-more-category');
      
      if (this.useMetafields) {
          this.bindCategoryEvents();
      } else {
          this.allItems = this.querySelectorAll('.collections-listing__item');
          this.visibleCount = this.itemsPerBatch;
          this.setInitialVisibility();
          this.bindEvents();
      }

      this.handleExpandedParameter();
      window.addEventListener('hashchange', this.boundHandleHashChange);
  }

  disconnectedCallback() {
      window.removeEventListener('hashchange', this.boundHandleHashChange);
  }

  setInitialVisibility() {
      this.allItems.forEach((item, index) => {
          if (index < this.visibleCount) {
              item.classList.add('is-visible');
          } else {
              item.classList.remove('is-visible');
          }
      });

      if (this.allItems.length <= this.visibleCount) {
          this.hideLoadMoreButton();
      }
  }

  bindEvents() {
      if (this.loadMoreButton) {
          this.loadMoreButton.addEventListener('click', (event) => {
              const hiddenItems = this.querySelectorAll('.collections-listing__item:not(.is-visible)');
              
              for (let i = 0; i < Math.min(this.itemsPerBatch, hiddenItems.length); i++) {
                  hiddenItems[i].classList.add('is-visible');
              }
              
              const remainingHidden = this.querySelectorAll('.collections-listing__item:not(.is-visible)');
              if (remainingHidden.length === 0) {
                  event.target.style.display = 'none';
              }
          });
      }
  }

  handleExpandedParameter() {
      let expandedSection = null;
      let hasExpandedParam = false;
      
      const urlParams = new URLSearchParams(window.location.search);
      expandedSection = urlParams.get('expanded');
      if (expandedSection) {
          hasExpandedParam = true;
      }
      
      if (!expandedSection) {
          const hash = window.location.hash;
          if (hash && hash.includes('?')) {
              const hashParams = new URLSearchParams(hash.split('?')[1]);
              expandedSection = hashParams.get('expanded');
              if (expandedSection) {
                  hasExpandedParam = true;
              }
          }
      }
      
      if (expandedSection && hasExpandedParam) {
          const targetSection = document.querySelector(`collections-listing[data-section-group-id="${expandedSection}"]`) ||
                               document.querySelector(`collections-listing[id="${expandedSection}"]`) ||
                               document.getElementById(expandedSection);
          
          if (targetSection) {
              const loadMoreButton = targetSection.querySelector('#loadMoreCollections');
              if (loadMoreButton) {
                  loadMoreButton.style.display = 'none';
              }
              
              setTimeout(() => {
                  targetSection.scrollIntoView({ 
                      behavior: 'smooth', 
                      block: 'start' 
                  });
                  
                  setTimeout(() => {
                      if (loadMoreButton) {
                          loadMoreButton.click();
                      }
                  }, 800);
                  
              }, 100);
          }
      }
  }

  bindCategoryEvents() {
      this.categoryLoadMoreButtons.forEach(button => {
          button.addEventListener('click', (e) => {
              const category = e.target.dataset.category;
              this.loadMoreCategory(category);
          });
      });
  }

  loadMoreCategory(categoryName) {
      const categorySection = this.querySelector(`[data-category="${categoryName}"]`);
      const hiddenItems = categorySection.querySelectorAll('.collections-listing__item:not(.is-visible)');
      const itemsToShow = Array.from(hiddenItems).slice(0, this.itemsPerBatch);
      
      itemsToShow.forEach(item => {
          item.classList.add('is-visible');
      });

      // Hide button if no more items to show
      if (hiddenItems.length <= this.itemsPerBatch) {
          const loadMoreButton = categorySection.querySelector('.load-more-category');
          if (loadMoreButton) {
              loadMoreButton.style.display = 'none';
          }
      }
  }

  loadMore() {
      const remainingItems = Array.from(this.allItems).slice(this.visibleCount);
      
      remainingItems.forEach(item => {
          item.classList.add('is-visible');
      });

      this.visibleCount = this.allItems.length;

      this.hideLoadMoreButton();
  }

  hideLoadMoreButton() {
      if (this.loadMoreButton) {
          this.loadMoreButton.style.display = 'none';
      }
  }
}

customElements.define('collections-listing', CollectionsListing);

// Section Block Merger for bypassing 50-block limit
class SectionBlockMerger {
    constructor() {
        this.init();
    }

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.mergeBlocks());
        } else {
            this.mergeBlocks();
        }
    }

    mergeBlocks() {
        const collectionSections = document.querySelectorAll('collections-listing[data-section-group-id]');
        const sectionGroups = {};

        collectionSections.forEach(section => {
            const groupId = section.dataset.sectionGroupId;
            if (!groupId) return;

            if (!sectionGroups[groupId]) {
                sectionGroups[groupId] = [];
            }
            sectionGroups[groupId].push(section);
        });

        Object.keys(sectionGroups).forEach(groupId => {
            const sections = sectionGroups[groupId];
            if (sections.length <= 1) return;

            this.mergeSectionBlocks(sections, groupId);
        });
    }

    mergeSectionBlocks(sections, groupId) {
        const primarySection = sections[0];
        const primaryGrid = primarySection.querySelector('.collections-listing__grid');
        
        if (!primaryGrid) return;

        let allBlocks = [];
        let totalBlockCount = 0;

        sections.forEach((section, sectionIndex) => {
            const grid = section.querySelector('.collections-listing__grid');
            if (!grid) return;

            const blocks = Array.from(grid.querySelectorAll('.collections-listing__item'));
            
            blocks.forEach((block, blockIndex) => {
                block.dataset.sourceSection = sectionIndex + 1;
                block.dataset.originalIndex = blockIndex + 1;
                totalBlockCount++;
            });

            if (sectionIndex === 0) {
                allBlocks = [...blocks];
            } else {
                blocks.forEach(block => {
                    primaryGrid.appendChild(block);
                    allBlocks.push(block);
                });
                
                section.style.display = 'none';
            }
        });

        primarySection.dataset.totalBlocks = totalBlockCount;
        primarySection.dataset.mergedSections = sections.length;

        if (primarySection.connectedCallback) {
            primarySection.connectedCallback();
        }

        this.updateLoadMoreForMergedSection(primarySection, totalBlockCount);
    }

    updateLoadMoreForMergedSection(section, totalBlocks) {
        const loadMoreButton = section.querySelector('#loadMoreCollections');
        if (!loadMoreButton) return;

        const itemsPerBatch = parseInt(section.dataset.itemsPerBatch) || 10;
        
        if (totalBlocks > itemsPerBatch) {
            loadMoreButton.style.display = '';
        }
    }
}

new SectionBlockMerger();

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.updateCountdown = this.updateCountdown.bind(this);
  }

  connectedCallback() {
    this.updateCountdown();
    this.interval = setInterval(this.updateCountdown, 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  padNumber(num) {
    return num.toString().padStart(2, '0');
  }

  updateCountdown() {
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0);
    const diff = nextMonth - now;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const formattedDays = this.padNumber(days);
    const formattedHours = this.padNumber(hours);
    const formattedMinutes = this.padNumber(minutes);
    const formattedSeconds = this.padNumber(seconds);

    this.innerHTML = `Launches in ${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }
}

customElements.define('countdown-timer', CountdownTimer);

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-countdown]').forEach(element => {
    if (!element.querySelector('countdown-timer')) {
      element.appendChild(document.createElement('countdown-timer'));
    }
  });

  document.querySelectorAll('img.needsclick').forEach(img => {
    img.style.display = 'block !important';
  });
});

// Override Magic360 options before it initializes
window.Magic360 = window.Magic360 || {};
Magic360.options = Magic360.options || {};

Magic360.options['reverse-column'] = true;

// If your images are multi-row, you can also add:
// Magic360.options['reverse-row'] = true;